var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderTest-container"},[_c('div',{staticClass:"title"},[_vm._v(" cnptOS工业操作系统构成 ")]),_c('div',{staticClass:"box"},_vm._l((_vm.list),function(i){return _c('div',{key:i.tit,staticClass:"item"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(i.tit))]),_c('div',{staticClass:"info"},[_vm._v(_vm._s(i.info))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }